require('./bootstrap');
import Vue from 'vue';

import VueMask from 'v-mask'
Vue.use(VueMask);

import { VueMaskDirective } from 'v-mask'

Vue.directive('mask', VueMaskDirective);

import { VueMaskFilter } from 'v-mask'

Vue.filter('VMask', VueMaskFilter)

import booking_form_view from './views/booking/form.vue';
window.vue_booking = new Vue({
    data:{
    },
    components: {
        'form-view': booking_form_view,
    },
    methods:{
    }
}).$mount('#booking-vue-app');
